// 009 Álbum compartido — lógica pura de tope/estado (espejo de la RPC upload_guest_photo).
// Mantener sincronizado con supabase/migrations/*_album_rpcs.sql (la BD es la autoridad;
// esto sirve al cliente para el aviso de reemplazo y a los tests como especificación).

/** Tope de fotos NO ocultas por invitado (FR-013). */
export const ALBUM_PHOTO_CAP = 10;

export type AlbumPhotoState = 'pending' | 'approved' | 'hidden';

export interface CapPhoto {
  id: string;
  created_at: string; // ISO
  is_hidden: boolean;
}

/** Estado derivado de una foto (data-model.md). Oculta prevalece sobre aprobada. */
export function photoState(isApproved: boolean, isHidden: boolean): AlbumPhotoState {
  if (isHidden) return 'hidden';
  return isApproved ? 'approved' : 'pending';
}

/** Estado inicial al subir según el modo de la invitación (auto-aprobar por defecto). */
export function initialApproval(autoApprove: boolean): boolean {
  return autoApprove;
}

/** Cuántas fotos del invitado cuentan para el tope (solo NO ocultas). */
export function countTowardCap(photos: CapPhoto[]): number {
  return photos.filter((p) => !p.is_hidden).length;
}

/** ¿Subir una más excede el tope? (dispara reemplazo / aviso). */
export function isAtCap(photos: CapPhoto[]): boolean {
  return countTowardCap(photos) >= ALBUM_PHOTO_CAP;
}

/**
 * Foto que se reemplazaría al subir en el tope: la MÁS ANTIGUA no oculta del invitado
 * (por created_at ascendente). Devuelve null si aún hay cupo.
 */
export function selectPhotoToReplace(photos: CapPhoto[]): string | null {
  if (!isAtCap(photos)) return null;
  const candidates = photos
    .filter((p) => !p.is_hidden)
    .sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
  return candidates.length > 0 ? candidates[0].id : null;
}
